
import _ from 'lodash';
import PropTypes from 'prop-types';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import AuthMessageComponent from '../AuthMessageComponent/AuthMessageComponent';
import styles from '../CommonLogin.module.scss';
import metadata from './SasriaUpdatePasswordComponent.metadata.json5';

function SasriaUpdatePasswordComponent(props) {
    
    const { onBackToSignIn } = props;

    const resolvers = {
        resolveClassNameMap: styles,
       
        resolveCallbackMap: {
            handleBackToSignIn: onBackToSignIn
        },
        resolveComponentMap: {
            authmessagecomponent: AuthMessageComponent
        }
    };
   const overrides = {};
    return renderContentFromMetadata(metadata.componentContent, overrides, resolvers);
}

SasriaUpdatePasswordComponent.propTypes = {
    onBackToSignIn: PropTypes.func
};

SasriaUpdatePasswordComponent.defaultProps = {
    onBackToSignIn: undefined
};

export default SasriaUpdatePasswordComponent;
